import { render, staticRenderFns } from "./modal-tenants.vue?vue&type=template&id=53d075f8&scoped=true"
import script from "./modal-tenants.vue?vue&type=script&lang=js"
export * from "./modal-tenants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d075f8",
  null
  
)

export default component.exports